import { render, staticRenderFns } from "./KioskOrderItem.vue?vue&type=template&id=3a76ebf0&"
import script from "./KioskOrderItem.vue?vue&type=script&lang=js&"
export * from "./KioskOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports